import React from "react";
import copy from "../content/smleLanding.json";
import samples from "../content/smleSamples.json";

// Shared by the interactive QBank and the build-time HTML renderer.
// Keep this component independent of browser APIs, authentication and live counts.
export default function SmleLandingContent({ language = "en", onSampleReveal }: { language?: "en" | "ar"; onSampleReveal?: () => void }) {
    const text = copy[language];
    return <div className="smle-landing" lang={language} dir={language === "ar" ? "rtl" : "ltr"}>
        <section className="smle-hero">
            <a className="smle-language" href={text.languagePath} hrefLang={language === "ar" ? "en" : "ar"}>{text.language}</a>
            <p className="smle-eyebrow">{text.eyebrow}</p>
            <h1>{text.heading}</h1>
            <p>{text.intro}</p>
            <div className="smle-actions">
                <a className="smle-primary" href="#collections">{text.browse}</a>
                <a href="#sample-questions">{text.samples}</a>
                <a href={`/pricing?lang=${language}`}>{text.plans}</a>
                <a href="/qbank/smle/mock-exams">{text.mock}</a>
            </div>
        </section>
        <div className="smle-grid">
            <section><h2>{text.coverageHeading}</h2><p>{text.coverage}</p></section>
            <section><h2>{text.stepsHeading}</h2><ol>{text.steps.map(step => <li key={step}>{step}</li>)}</ol></section>
        </div>
        <section id="sample-questions">
            <p className="smle-eyebrow">SMLE QBank</p><h2>{text.sampleHeading}</h2><p>{text.sampleIntro}</p>
            <div className="smle-grid">{samples.map(sample => <article className="smle-sample" key={sample.id} id={sample.id}>
                <div lang="en" dir="ltr">
                    <p className="smle-eyebrow">{sample.topic}</p>
                    <h3>{sample.question}</h3>
                    <ol type="A">{sample.options.map(option => <li key={option}>{option}</li>)}</ol>
                </div>
                <details onToggle={event => { if (event.currentTarget.open) onSampleReveal?.(); }}><summary>{text.answer}</summary><div lang="en" dir="ltr">
                    <p><strong>{sample.answer}</strong></p><p>{sample.explanation}</p>
                    <a href={sample.sourceUrl}>{sample.sourceTitle}</a>
                </div></details>
            </article>)}</div>
        </section>
        <section className="smle-faq"><h2>{text.faqHeading}</h2>{text.faq.map(item => <details key={item.q}>
            <summary>{item.q}</summary><p>{item.a}</p>
        </details>)}</section>
        <p className="smle-disclaimer">{text.disclaimer}</p>
    </div>;
}
